export default __webpack_public_path__ + "static/media/new_room_1.56fc089d.png";